/* Il Botteghino - scheda prodotto: galleria, scelta delle varianti, acquisto, barra mobile, correlati.
   Nessuna libreria. Si carica solo sulla scheda, con defer, dopo botteghino.js (che fornisce BT.money e il carrello).
   Dati: il JSON della pagina ([data-product-json]). Le regole di disponibilità sono le stesse di snippets/bt-variant-picker.liquid. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = $("[data-product-root]");
  if (!root) return;
  var calm = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
  var money = function (c) { return window.BT && BT.money ? BT.money(c) : (c / 100).toFixed(2).replace(".", ",") + " €"; };

  /* ---------- galleria ---------- */
  var gal = $(".bt-gallery", root), track = gal && $(".bt-gallery__slides", gal);
  var slides = gal ? $$(".bt-gallery__slide", gal) : [], thumbs = gal ? $$(".bt-gallery__thumb", gal) : [];
  var strip = function () { return !!track && getComputedStyle(track).display === "flex"; };
  function hydrate(i) { /* scarica la foto i-esima (le lazy non hanno src finche' non servono) */
    var im = slides[i] && $("img[data-src]", slides[i]);
    if (!im) return;
    if (im.getAttribute("data-srcset")) im.srcset = im.getAttribute("data-srcset");
    im.src = im.getAttribute("data-src");
    im.removeAttribute("data-src"); im.removeAttribute("data-srcset");
  }
  function hydrateAround(i) { hydrate(i); hydrate(i + 1); hydrate(i - 1); }
  function show(i) {
    hydrateAround(i);
    slides.forEach(function (s, k) { s.classList.toggle("is-active", k === i); });
    thumbs.forEach(function (t, k) { t.setAttribute("aria-current", k === i ? "true" : "false"); });
  }
  function go(i, fast) {
    show(i);
    if (strip()) track.scrollTo({ left: i * track.clientWidth, behavior: fast ? "auto" : calm });
  }
  function goPos(pos) { /* porta alla foto con quella posizione in product.media */
    for (var i = 0; i < slides.length; i++) if (+slides[i].getAttribute("data-pos") === pos) { go(i); return; }
  }
  if (thumbs.length) {
    var first = slides.map(function (s) { return s.classList.contains("is-active"); }).indexOf(true);
    if (first > 0 && strip()) track.scrollLeft = first * track.clientWidth; /* variante scelta con foto che non è la prima */
  }
  var activeNow = function () { return Math.max(0, slides.map(function (s) { return s.classList.contains("is-active"); }).indexOf(true)); };
  if (document.readyState === "complete") hydrateAround(activeNow());
  else window.addEventListener("load", function () { hydrateAround(activeNow()); });
  function zoom() {
    var box = document.getElementById("ingrandimento"), cur = gal && $(".bt-gallery__slide.is-active img", gal);
    if (!box || !cur) return;
    var big = $("img", box);
    big.src = cur.getAttribute("data-big") || cur.currentSrc || cur.src;
    big.alt = cur.alt;
    box.showModal();
  }
  if (track) {
    var tick = 0; /* lo scorrimento a scatti su telefono aggiorna i puntini; "scroll" non risale, quindi in cattura */
    root.addEventListener("scroll", function (e) {
      if (e.target !== track || !strip()) return;
      window.cancelAnimationFrame(tick);
      tick = window.requestAnimationFrame(function () { show(Math.round(track.scrollLeft / (track.clientWidth || 1))); });
    }, { capture: true, passive: true });
  }

  /* ---------- varianti e acquisto ---------- */
  var D = null, js = $("script[data-product-json]", root.parentNode) || $("script[data-product-json]");
  try { D = JSON.parse(js.textContent); } catch (e) { D = null; }
  var form = D && $("[data-product-form]", root);
  var V, N, K, T, sel, groups, idEl, btn, exp, stock, cmp, thumbImg, links, slot, busy = false;
  var saleLabel, saleBadge, saveEl, stickyNow, stickyWas;

  if (form) {
    V = D.variants; N = D.n; K = D.k; T = D.t; sel = D.s.slice();
    groups = $$(".bt-option", root);
    idEl = $("[data-variant-input]", form); btn = $("[data-pdp-buy]", form); exp = $("[data-express]", form);
    stock = $("[data-pdp-stock]", root); cmp = $("[data-compare]", root); thumbImg = $(".bt-sticky__thumb img", root);
    saleLabel = $("[data-sale-label]", root); saleBadge = $("[data-sale-badge]", root); saveEl = $("[data-save]", root);
    stickyNow = $("[data-sticky-now]", root); stickyWas = $("[data-sticky-was]", root);
    links = $("[data-notify-links]", root); slot = $("[data-notify-slot]", root);
    if (slot && $(".bt-notify__msg", slot)) slot.hidden = false; /* dopo l'invio del modulo la conferma o l'errore devono vedersi */
    if (window.BT) form.removeAttribute("action"); /* un solo add_to_cart: l'aggiunta passa da bt:add, non dall'invio del modulo */
  }

  function fits(v, skip) { for (var j = 0; j < N; j++) if (j !== skip && sel[j] && v.o[j] !== sel[j]) return false; return true; }
  function free(i, val) { return V.some(function (v) { return v.a && v.o[i] === val && fits(v, i); }); }
  function pick() {
    if (!N) return V[0];
    for (var j = 0; j < N; j++) if (!sel[j]) return null;
    return V.filter(function (v) { return fits(v, -1); })[0] || null;
  }
  function group(i) { return groups.filter(function (g) { return +g.getAttribute("data-opt") === i; })[0]; }
  function missing() { for (var i = 0; i < N; i++) if (!sel[i]) return i; return -1; }

  function need() { /* manca una scelta: messaggio, scorrimento e focus sul primo valore */
    var i = missing(), g = i < 0 ? null : group(i);
    if (!g) return;
    var m = $(".bt-error", g), r = $('[role="radio"]:not([aria-disabled="true"])', g);
    g.classList.add("is-missing");
    if (m) m.hidden = false;
    g.scrollIntoView({ block: "center", behavior: calm });
    if (r) r.focus({ preventScroll: true });
  }

  function update(user) {
    groups.forEach(function (g) { var i = +g.getAttribute("data-opt"); if (sel[i] && !free(i, sel[i])) sel[i] = ""; });
    groups.forEach(function (g) { /* una sola scelta possibile: la si sceglie (non per il colore) */
      var i = +g.getAttribute("data-opt");
      if (sel[i] || K[i] === "color") return;
      var f = $$('[role="radio"]', g).filter(function (b) { return free(i, b.getAttribute("data-value")); });
      if (f.length === 1) sel[i] = f[0].getAttribute("data-value");
    });
    groups.forEach(function (g) {
      var i = +g.getAttribute("data-opt"), lab = $("[data-label]", g), m = $(".bt-error", g);
      $$('[role="radio"]', g).forEach(function (r) {
        var val = r.getAttribute("data-value"), ok = free(i, val), sw = r.classList.contains("bt-swatch");
        r.setAttribute("aria-checked", sel[i] === val ? "true" : "false");
        r.classList.toggle("is-soldout", !ok);
        if (ok) { r.removeAttribute("aria-disabled"); if (sw) r.setAttribute("aria-label", val); else r.removeAttribute("aria-label"); }
        else { r.setAttribute("aria-disabled", "true"); r.setAttribute("aria-label", T[K[i] === "size" ? "s_size" : "s_other"].replace("{value}", val)); }
      });
      if (lab) lab.textContent = sel[i] || T.choose;
      if (sel[i]) { g.classList.remove("is-missing"); if (m) m.hidden = true; }
    });

    var r = pick(), c = V.filter(function (v) { return fits(v, -1); }), av = c.filter(function (v) { return v.a; });
    var pool = av.length ? av : c, ps = pool.map(function (v) { return v.p; });
    var lo = Math.min.apply(null, ps), hi = Math.max.apply(null, ps), p = r ? r.p : lo;
    var txt = r || lo === hi ? money(p) : T.from.replace("{price}", money(lo));
    $$("[data-pdp-price]", root).forEach(function (el) { el.textContent = txt; });
    /* sconto: solo se compare_at_price è maggiore del prezzo (dato del catalogo). Senza scelta completa conta la variante più economica del gruppo;
       a parità di prezzo vince il compare più piccolo, così lo sconto compare solo se è vero per tutte (stessa regola di main-product.liquid).
       Con «Da €X» (prezzi diversi) lo sconto c'è solo se tutte le varianti del gruppo sono in sconto: con una taglia a prezzo pieno il -30% non vale per tutto il prodotto */
    var old = 0, first = true;
    if (r) old = r.c > r.p ? r.c : 0;
    else pool.forEach(function (v) {
      var e = v.c > v.p ? v.c : 0;
      if (v.p !== lo || (!first && e >= old)) return;
      old = e; first = false;
    });
    if (!r && lo !== hi && pool.some(function (v) { return !(v.c > v.p); })) old = 0;
    old = old > p ? old : 0;
    var pct = old ? Math.floor(((old - p) * 200 + old) / (old * 2)) : 0; /* intero, la metà per eccesso (come bt-pct.liquid) */
    if (cmp) { cmp.hidden = !old; $("[data-compare-val]", cmp).textContent = old ? money(old) : ""; }
    if (saleLabel) saleLabel.hidden = !old;
    if (saleBadge) { saleBadge.hidden = !(old && pct > 0); saleBadge.textContent = old && pct > 0 ? "-" + pct + "%" : ""; }
    if (saveEl) { var sv = old && (r || lo === hi); saveEl.hidden = !sv; saveEl.textContent = sv ? T.save.replace("{price}", money(old - p)) : ""; }
    if (stickyWas) { stickyWas.hidden = !old; var sw = $("[data-sticky-was-val]", stickyWas); if (sw) sw.textContent = old ? money(old) : ""; }
    if (stickyNow) stickyNow.hidden = !old;
    var s = r ? (r.a ? (r.l ? "low" : "in") : "out") : (av.length ? "in" : "out");
    stock.textContent = T[s];
    stock.className = "bt-stock" + (s === "low" ? " bt-stock--low" : s === "out" ? " bt-stock--out" : "");
    btn.textContent = T.add.replace("{price}", money(p));

    var id = r && r.a ? String(r.id) : "";
    if (idEl.value !== id) { idEl.value = id; idEl.disabled = !id; idEl.dispatchEvent(new Event("change", { bubbles: true })); }
    var m = missing(), g = m < 0 ? null : group(m), rg = g && $('[role="radiogroup"]', g);
    if (rg) btn.setAttribute("data-needs", rg.id); else btn.removeAttribute("data-needs");
    if (exp) exp.hidden = !(r && r.a); /* i pulsanti Apple Pay / Google Pay valgono solo per una variante scelta e acquistabile */

    var im = (r || pool[0]).i; /* barra mobile: miniatura della variante */
    if (im && thumbImg) { thumbImg.src = im; thumbImg.removeAttribute("srcset"); }
    if (user) {
      var vm = r && r.m ? r : pool.filter(function (v) { return v.m; })[0];
      if (vm) goPos(vm.m);
      try {
        var u = new URL(window.location.href);
        if (r) u.searchParams.set("variant", r.id); else u.searchParams.delete("variant");
        window.history.replaceState(null, "", u);
      } catch (e) { /* URL non modificabile: la scelta resta valida */ }
    }

    if (links) { /* «Avvisami per la taglia X»: varianti esaurite che differiscono dalla scelta per una sola opzione */
      links.textContent = "";
      V.forEach(function (v) {
        if (v.a) return;
        var d = -1, n = 0;
        for (var j = 0; j < N; j++) if (v.o[j] !== sel[j]) { d = j; n++; }
        if (n !== 1) return;
        var b = document.createElement("button");
        b.type = "button"; b.className = "bt-link"; b.setAttribute("data-notify-for", v.id);
        b.textContent = T["n_" + K[d]].replace("{value}", v.o[d]);
        links.appendChild(b);
      });
      links.hidden = !links.firstChild;
      if (slot && !$(".bt-notify__msg", slot)) slot.hidden = true;
    }
  }

  function add() {
    var r = pick();
    if (!r) { need(); return; }
    if (!r.a || busy) return;
    busy = true; btn.setAttribute("aria-busy", "true");
    window.setTimeout(release, 6000);
    document.dispatchEvent(new CustomEvent("bt:add", { detail: { id: r.id, quantity: 1, properties: {} } }));
  }
  function release() { busy = false; if (btn) btn.removeAttribute("aria-busy"); }

  function notifyFor(id) { /* mostra il modulo «Avvisami» per la variante scelta e aggiorna il testo della richiesta */
    var v = V.filter(function (x) { return String(x.id) === String(id); })[0];
    if (!slot || !v) return;
    var body = $("[data-notify-body]", slot);
    if (body) body.value = D.nb.a + ", " + D.nb.w + " " + v.t + ", " + D.nb.u + "?variant=" + v.id;
    slot.hidden = false;
    slot.scrollIntoView({ block: "center", behavior: calm });
    var f = $("input[type=email]", slot);
    if (f) f.focus({ preventScroll: true });
  }

  /* ---------- eventi (delegati sulla radice) ---------- */
  root.addEventListener("click", function (e) {
    var t = e.target, r = t.closest('[role="radio"]'), th = t.closest(".bt-gallery__thumb"), n;
    if (r && form) {
      if (r.getAttribute("aria-disabled") === "true") return;
      var g = r.closest(".bt-option");
      sel[+g.getAttribute("data-opt")] = r.getAttribute("data-value");
      update(true);
    } else if (th) {
      go(thumbs.indexOf(th));
    } else if (t.closest(".bt-gallery__zoom")) {
      zoom();
    } else if (form && t.closest("[data-sticky-add]")) {
      add();
    } else if (form && (n = t.closest("[data-notify-for]"))) {
      notifyFor(n.getAttribute("data-notify-for"));
    }
  });
  if (form) {
    form.addEventListener("submit", function (e) {
      if (!window.BT) { if (!pick()) { e.preventDefault(); need(); } return; } /* senza il nucleo: invio normale del modulo */
      e.preventDefault();
      add();
    });
    document.addEventListener("bt:cart:updated", release);
    document.addEventListener("bt:cart:error", release);
  }

  /* ---------- barra di acquisto su telefono ---------- */
  var cta = $("[data-sticky-watch]", root), bar = $(".bt-sticky", root);
  if (cta && bar && "IntersectionObserver" in window) {
    new IntersectionObserver(function (en) {
      bar.classList.toggle("is-visible", !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
    }).observe(cta);
  }

  /* ---------- descrizione del negozio: i vecchi pulsanti «Descrizione» non fanno più nulla ---------- */
  $$(".bt-desc button", root).forEach(function (b) { b.disabled = true; });

  /* ---------- correlati: raccomandazioni di Shopify al posto del ripiego, quando la sezione sta per vedersi ---------- */
  var rel = $("[data-related-url]");
  if (rel && "IntersectionObserver" in window && window.fetch) {
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return;
      io.disconnect();
      window.fetch(rel.getAttribute("data-related-url"), { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.text() : ""; })
        .then(function (h) {
          var g = $("[data-related-grid]", new DOMParser().parseFromString(h, "text/html")), cur = $("[data-related-grid]", rel);
          if (g && cur && g.children.length >= cur.children.length) { cur.innerHTML = g.innerHTML; cur.setAttribute("data-count", g.children.length); }
        })
        .catch(function () { /* resta il ripiego */ });
    }, { rootMargin: "600px 0px" });
    io.observe(rel);
  }
})();
